import AdvanceTable from 'componentes/common/advance-table/AdvanceTable.js';
import AdvanceTableSearchBox from 'componentes/common/advance-table/AdvanceTableSearchBox.js';
import IconButton from 'componentes/common/IconButton.js';
import BtnExportToExcell from 'componentes/generic/ExportToExcel.js';
import { FormatDateFull } from 'helpers/FormatData.js';
import React, { useMemo } from 'react';
import { Card, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';
import AdvanceTableProvider from 'context/AdvanceTableProvider.js';
import useAdvanceTable from 'hooks/useAdvanceTable.js';
import AdvanceTableFooter from 'componentes/common/advance-table/AdvanceTableFooter.js';
import SubtleBadge from 'componentes/common/SubtleBadge.js';
import { statusIcons } from 'helpers/GetIcons.js';
const QuejasList = ({ dataReport, subTitle }) => {
  const data = useMemo(() => dataReport, []);

  const titleReport = 'Quejas Recibidas';
  const columns = [
    {
      accessorKey: 'expediente',
      header: 'Expediente', //Header: 'Info'
      headerProps: { className: 'pe-1' },
      id: 'expediente',
      cellProps: {
        className: 'py-2'
      },
      cell: rowData => {
        return (
          <>
            <Link
              to={'/Quejas/Detalle/' + rowData.row.original.idrecepcionqueja}
            >
              <strong>{rowData.row.original.expediente}</strong>
            </Link>
            <p className="mb-0 text-500">
              Fecha de Recepcion: {rowData.row.original.fecharecepcion || ''}
            </p>{' '}
            <p className="mb-0 text-500">
              Delegacion: {rowData.row.original.delegacion || ''}
            </p>{' '}
            <p className="mb-0 text-500">
              Proxima Audiencia: {FormatDateFull(rowData.row.original.fecha)}
            </p>
          </>
        );
      }
    },
    {
      id: 'determinante',
      accessorKey: 'determinante',
      header: 'Cliente', //'Customer'
      headerProps: { className: 'pe-7' },
      cell: rowData => {
        return (
          <>
            <strong>{rowData.row.original.subcliente}</strong>

            <p className="mb-0 text-500">
              <strong>Determinante:{rowData.row.original.determinante}</strong>
            </p>
            <p className="mb-0 text-500">{rowData.row.original.tipoproducto}</p>
            <p className="mb-0 text-500">
              Folio Oracle: {rowData.row.original.vc_folioext || ''}
            </p>
          </>
        );
      }
    },
    {
      id: 'nombreconsumidor',
      accessorKey: 'nombreconsumidor',
      header: 'Datos de Queja', //'Location',
      headerProps: { className: 'pe-7' },
      cell: rowData => {
        return (
          <>
            <strong>{rowData.row.original.clasificacionqueja}</strong>
            <p className="mb-0 text-500">
              Fecha de Queja: {rowData.row.original.fechaqueja}
            </p>
            <p className="mb-0 text-500">{rowData.row.original.status}</p>
            <p className="mb-0 text-500">
              {rowData.row.original.nombreconsumidor}
            </p>
          </>
        );
      }
    },
    {
      id: 'vc_folioext',
      accessorKey: 'vc_folioext',
      header: 'Acciones',
      headerProps: {
        className: 'text-center'
      },
      cellProps: {
        className: 'fs-0'
      },
      cell: rowData => {
        const status = rowData.row.original.status;
        return (
          <OverlayTrigger placement="top" overlay={<Tooltip>Acciones</Tooltip>}>
            <>
              <IconButton
                variant="falcon-default"
                size="sm"
                className=" btn fs-11 mt-lg-2 w-lg-100"
                icon="arrow-right"
              >
                <Link
                  as="link"
                  to={
                    '/Quejas/Detalle/' + rowData.row.original.idrecepcionqueja
                  }
                >
                  <strong>Ver Detalle</strong>
                </Link>
              </IconButton>
              <SubtleBadge
                pill
                bg={statusIcons.find(item => item.status === status).color}
                className="d-block"
              >
                {rowData.row.original.status}
              </SubtleBadge>
              <IconButton
                size="sm"
                variant="primary"
                disabled
                className=" btn fs-11 mt-lg-2 w-lg-100"
                icon={
                  rowData.row.original.espresencial == 'NO' ? 'users' : 'user'
                }
                onClick={() => {}}
              >
                {rowData.row.original.espresencial == 'NO'
                  ? 'Virtual'
                  : 'Presencial'}
              </IconButton>{' '}
            </>
          </OverlayTrigger>
        );
      }
    }
  ];

  const table = useAdvanceTable({
    data,
    columns,
    sortable: true,
    pagination: true,
    perPage: 15
  });
  return (
    <>
      {data && data.length > 0 ? (
        <Card className="mb-3">
          <Card.Header>
            <Row className="flex-between-center">
              <Col xs={4} sm="auto" className="  pe-0">
                <Row>
                  <Col>
                    <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">
                      Quejas
                    </h5>
                  </Col>
                </Row>
                <Row>
                  {subTitle && (
                    <Col>
                      <h6 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">
                        {subTitle}
                      </h6>
                    </Col>
                  )}
                </Row>
              </Col>
              <Col xs={8} sm="auto" className="ms-auto text-end ps-0">
                <div id="orders-actions">
                  <IconButton
                    variant="falcon-default"
                    size="sm"
                    icon="plus"
                    transform="shrink-3"
                  >
                    <Link
                      className="d-none d-sm-inline-block ms-1"
                      to={'/Quejas/New'}
                    >
                      <strong>Nuevo Expediente</strong>
                    </Link>
                  </IconButton>
                  {dataReport && (
                    <BtnExportToExcell
                      dataReport={dataReport}
                      fileName={titleReport}
                    ></BtnExportToExcell>
                  )}
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body className="p-0">
            <AdvanceTableProvider {...table}>
              <Row className="flex-end-center mb-3">
                <Col xs="auto" sm={6} lg={4}>
                  <AdvanceTableSearchBox />
                </Col>
              </Row>
              <AdvanceTable
                headerClassName="bg-200 text-nowrap align-middle"
                rowClassName="align-middle white-space-nowrap"
                tableProps={{
                  bordered: true,
                  striped: true,
                  className: 'fs-10 mb-0 overflow-hidden'
                }}
              />
              <div className="mt-3 mt-2 mb-2 mx-2">
                <AdvanceTableFooter rowInfo navButtons rowsPerPageSelection />
              </div>
            </AdvanceTableProvider>
          </Card.Body>
        </Card>
      ) : (
        <div className="text-center">
          <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">
            No hay Quejas en el periodo seleccionado
          </h5>
        </div>
      )}
    </>
  );
};
QuejasList.propTypes = {
  dataReport: PropTypes.array.isRequired,
  subTitle: PropTypes.string.isRequired
};
export default QuejasList;
